// extracted by mini-css-extract-plugin
module.exports = {"container":"Main_container__3YkPS","text":"Main_text__1ZDOQ","logout":"Main_logout__2XLpq","button":"Main_button__BkgW1"};